import NoOptionsMessage from './no-options-message/index.tsx';

// Default components that can be overridden and composed by the consumer.
export const components = {
	NoOptionsMessage,
};
